import { FC } from 'react';
import { AllieButton } from '../Buttons/Button';
import { 
  AllieCloseCircleOutlineIcon,
  AllieWarningOutlineIcon,
  AllieSearchOutline,
} from '../../styling/icons/Icons';
import { EmptyStateProps, EmptyStateType } from './EmptyState.types';
import { 
  StyledEmptyStateContainer, 
  StyledIconWrapper, 
  StyledTitle, 
  StyledDescription, 
  StyledButtonWrapper,
  StyledEmptyStateWrapper,
} from './EmptyState.styles';

const getIconByType = (type: EmptyStateType) => {
  const icons = {
    error: <AllieCloseCircleOutlineIcon />,
    warning: <AllieWarningOutlineIcon />,
    search: <AllieSearchOutline />,
  };
  
  return icons[type];
};

export const EmptyState: FC<EmptyStateProps> = ({
  type,
  title,
  descriptionLine1,
  descriptionLine2,
  buttonText,
  onRetry,
  isRetrying = false,
  size = 'large',
  background = 'white',
  className,
}) => {
  const icon = getIconByType(type);

  return (
    <StyledEmptyStateWrapper background={background} data-testid="error-state">
      <StyledEmptyStateContainer size={size} background={background} className={className}>
        <StyledIconWrapper size={size} background={background}>
          {icon}
        </StyledIconWrapper>
        
        <StyledTitle className={size === 'large' ? 'allie-text-body1' : 'allie-text-body2'}>
          {title}
        </StyledTitle>
        
        <StyledDescription
          className={
            size === 'large' ? 'allie-text-body2' : size === 'medium'
            ? 'allie-text-body2' : 'allie-text-body3'
          }
        >
          {descriptionLine1}
          {descriptionLine2 && (
            <>
              <br />
              {descriptionLine2}
            </>
          )}
        </StyledDescription>
        
        {onRetry && buttonText && (
          <StyledButtonWrapper size={size}>
            <AllieButton 
              allieType="secondary"
              allieSize={size === 'small' ? 'small' : 'medium'}
              corner="rounded"
              shadow={false}
              onClick={onRetry}
              loading={isRetrying}
            >
              {buttonText}
            </AllieButton>
          </StyledButtonWrapper>
        )}
      </StyledEmptyStateContainer>
    </StyledEmptyStateWrapper>
  );
};
